import React, { useState } from "react";
import { Box, DialogContent, Grid, CircularProgress, TextField,Typography,} from "@mui/material";
import { connect } from 'react-redux';
import { Actions } from "../../../../core/modules/Actions";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import ThumbnailUploadComponent from "../../../atom/Inputs/Thumbnail";

const AdminDocumentAdd = ({ onClose = () => { },courseId, current_document_id = null,addDocument, baseUrl}) => {
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [img, setImg] = useState(null);
    const [thumbnail, setThumbnail] = useState(null);
    const [documentError, setDocumentError] = useState(false);

    const [uploadStatus, setUploadStatus] = useState("");
    const [uploadBtnStatus, setUploadBtnStatus] = useState(false);
    const [abortController, setAbortController] = useState(null);

    const onReset = () => {
        setName("");
        setNameError("");
        setImg(null);
        setThumbnail(null);
        setDocumentError(false);
        setUploadStatus("");
        setUploadBtnStatus(false);
      };

    const handleNameChange = (e) => {
      const val = e.target.value;
      setName(val);
      if (val.includes(".")) {
        setNameError("Document name can not contain dots (.)");
      } else {
        setNameError("");
      }
      };

    const handleDocumentChange = (file) => {
      setImg(file);
      if (file) {
        setDocumentError(false);
      }
    };

    const handleThumbnailChange = (file) => {
      setThumbnail(file);
    };

   const onAddDocument = async () => {
  let hasError = false;

  // Validate Name
  if (name.includes(".")) {
    setNameError("Document name cannot contain dots (.)");
    hasError = true;
  }

  // Validate Document
  if (!img) {
    setDocumentError(true);
    hasError = true;
  }

  if (hasError || !courseId) return;

  setUploadStatus("Uploading...");
  setUploadBtnStatus(true);

  // Fallback to the full file name (including extension) if name is empty
  const typedName = name.trim();
  const fileExtension = img?.name?.split(".").pop();
  const finalName = typedName
    ? `${typedName}${fileExtension ? `.${fileExtension}` : ""}`
    : img?.name || "";

  const fd = new FormData();
  fd.append("name", finalName);
  fd.append("document", img);

  if (thumbnail) {
    fd.append("thumbnail", thumbnail);
  }

            const path =
              current_document_id != null && current_document_id  !== 0
                ? `documents/course/upload/${courseId}/${current_document_id}`
                : `documents/course/upload/${courseId}`;

            if (current_document_id != null && current_document_id !== 0) {
            localStorage.setItem("documentParentId", current_document_id);
        } else {
            localStorage.removeItem("documentParentId");
        }

            const controller = new AbortController(); // Create a new AbortController
            setAbortController(controller); // Store it in state

        try {
            await addDocument({ path, fd }, controller.signal);
            
            onReset();
            onClose(); // Close the dialog
        } catch (error) {
            console.error("Upload failed:", error);
            setUploadStatus(error?.message || "Upload failed. Please try again.");
            setUploadBtnStatus(false);
        }
    };

    const onCancelUpload = () => {
        if (abortController) {
            abortController.abort(); // Abort the ongoing API call
        }
        onReset(); // Reset the form
        onClose(); // Close the dialog
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <DialogContent sx={{ p: 3 }}>
                {/* Visual Loader Overlay: covers entire content container if uploading */}
                {uploadBtnStatus && (
                    <Box 
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <CircularProgress color="primary" />
                        <p style={{ marginTop: 10, fontFamily: 'Montserrat', fontWeight: 500, color: "#4E657C" }}>
                            {uploadStatus}
                        </p>
                    </Box>
                )}

                <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box mb={0.5}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#344054",
                        fontFamily: "Montserrat, sans-serif",
                      }}
                    >
                      Name
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    placeholder="Document name"
                    value={name}
                    onChange={handleNameChange}
                    disabled={uploadBtnStatus}
                    variant="outlined"
                    error={Boolean(nameError)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#F2F4F7",
                        borderRadius: "10px",
                        fontSize: "14px",
                        color: "#344054",
                        "& fieldset": {
                          border: nameError ? "1px solid #d06060" : "none",
                        },
                        "&:hover fieldset": {
                          border: nameError ? "1px solid #d06060" : "none",
                        },
                        "&.Mui-focused fieldset": {
                          border: nameError ? "1px solid #d06060" : "1px solid #9834F0",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "12px 16px",
                        "&::placeholder": {
                          color: "#98A2B3",
                          opacity: 1,
                        },
                      },
                    }}
                  />
                  {nameError && (
                    <p
                      style={{
                        color: "#d06060",
                        fontSize: 12,
                        fontWeight: 500,
                        fontFamily: "Montserrat",
                        marginTop: 4,
                        marginBottom: 0,
                      }}
                    >
                      {nameError}
                    </p>
                  )}
                </Grid>
                    <Grid item xs={12}>
                      <ThumbnailUploadComponent
                        label="Document"
                        description="PDF, PNG, JPG, JPEG etc."
                        accept={[".pdf", ".png", ".jpg", ".jpeg"]}
                        size={100 * 1024 * 1024}
                        value={img}
                        onChange={handleDocumentChange}
                        disabled={uploadBtnStatus}
                        required={true}
                      />
                      {documentError && (
                        <p
                          style={{
                            color: "#d06060",
                            fontSize: 12,
                            fontWeight: 500,
                            fontFamily: "Montserrat",
                            marginTop: 4,
                            marginBottom: 0,
                          }}
                        >
                          Please select a Document
                        </p>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                      <ThumbnailUploadComponent
                        label="Thumbnail"
                        description="PNG, JPG, JPEG up to 2MB"
                        accept={[".jpg", ".jpeg", ".png"]}
                        size={2 * 1024 * 1024}
                        value={thumbnail}
                        onChange={handleThumbnailChange}
                        disabled={uploadBtnStatus}
                      />
                    </Grid>

                    {/* Upload Status Message */}
                    {uploadStatus && (
                      <Grid item xs={12}>
                        <Box pt={1}>
                          <b>
                            <p
                              style={{
                                margin: 0,
                                color:
                                  uploadStatus.includes("failed") ||
                                  uploadStatus.includes("canceled")
                                    ? "red"
                                    : "green",
                              }}
                            >
                              {uploadStatus}
                            </p>
                          </b>
                        </Box>
                      </Grid>
                    )}

                  {/* Action Buttons */}
                  <Grid item xs={6} mt={2}>
                    <TextButtonComponet
                      onButtonClick={onCancelUpload}
                      text={"Cancel"}
                      classStyle="btn btn-secondary"
                    />
                    </Grid>
                    <Grid item xs={6} mt={2}>
                            <TextButtonComponet onButtonClick={onAddDocument} text={"Create"} isDisabled={uploadBtnStatus || Boolean(nameError)} />
                    </Grid>
                </Grid>
            </DialogContent>
    </Box>
    );
};

export default connect(null, {addDocument: Actions.document.addDocument,})(AdminDocumentAdd)